import React from 'react'
import { useTranslation } from 'react-i18next';
import { useLottie } from 'lottie-react'
import { Style } from './styleMiddle.js'
import { Chart } from './chart.jsx'

import IMG from '@assets/dashboard'
import { isEmptyValue } from '@helpers'
import animationData from './animation/electric-pole.json'
import { solar1, solar2, solar3 } from './animation/index.js';

import { Text } from '../style.js'

const generatedTimeObject = () => {
  let objetOfTime = {}
  Array(24 * 4)
    .fill(0)
    .forEach((_, i) => {
      if (i > 19 && i < 77) {
        let time = ('0' + ~~(i / 4) + ':0' + 60 * ((i / 4) % 1)).replace(/\d(\d\d)/g, '$1')

        objetOfTime = {
          ...objetOfTime,
          [time]: 0,
        }
      }
    })
  return objetOfTime
}

const generatedFilterTimeObject = graph => {
  let filterObjetOfTime = {}
  graph?.forEach(item => {
    if (item.pvGeneration) {
      let time = item.time.split('T')[1].slice(0, 5)
      filterObjetOfTime = {
        ...filterObjetOfTime,
        [time]: item.pvGeneration / 1000,
      }
    }
  })
  return filterObjetOfTime
}

export const Middle = ({ graph, pvPower, isEng, peakPower }) => {
  const currentPower = isEmptyValue({
    valueCheck: pvPower,
    display: (parseFloat(pvPower) / 1000).toFixed(2),
  })

  const { t } = useTranslation();


  const objetOfTime = generatedTimeObject()
  const filterObjetOfTime = generatedFilterTimeObject(graph)
  const chartData = { ...objetOfTime, ...filterObjetOfTime }
  const labels = Object.keys(objetOfTime)

  const data = {
    labels,
    datasets: [
      {
        label: 'My First Dataset',
        data: Object.values(chartData),
        backgroundColor: '#004AAD',
        datalabels: {
          display: false,
        },
        radius: 0,
        order: 3,
        fill: true,
      },
    ],
  }
  let listTime = []
  let listTime2 = []
  const chartConfig = {
    type: 'line',
    data,
    options: {
      layout: {
        padding: {
          left: 40,
          right: 50,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        responsive: true,
        tooltip: {
          display: false,
          enabled: false,
          active: false,
        },
      },
      scales: {
        x: {
          ticks: {
            autoSkip: false,
            minRotation: 0,
            maxRotation: 0,
            major: { enabled: true },
            color: context => {
              let time = context.tick.label.split(':')
              if (listTime.find(e => e === time[0])) {
                return 'transparent';
              } else {
                const hour = parseInt(time[0], 10); // Parse the hour as an integer
                if (hour % 2 === 0) { // Check if the hour is even
                  return 'transparent';
                } else {
                  listTime.push(time[0]);
                  if (context.tick.label === '19:00') {
                    listTime = [];
                  }
                  return 'black';
                }
              }
            },
            font: () => {
              return {
                size: 14,
                weight: 'bold',
              }
            },
          },
          grid: {
            display: true,
            ticks: {
              min: 0, // Set the minimum line height
              max: 2, // Set the maximum line height
            },
            color: context => {
              let time = context.tick.label.split(':')
              if (listTime2.find(e => e === time[0])) {
                return 'transparent';
              } else {
  
                  listTime2.push(time[0]);
                  if (context.tick.label === '19:00') {
                    listTime2 = [];
                  }
                  return 'black';
                
              }
            }, 
            lineWidth: 0.2,
            borderDash: [0, 5], 
            drawBorder: true,
          },
        },
      },
    },
  }
  const Animation = ({ options }) => {
    const { View } = useLottie(options)
    return View
  }
  const percent = (parseFloat(currentPower) / peakPower) * 100
  const solar = () => {
    if (percent && percent >= 67) {
      return solar3
    } else if (percent && percent >= 34) {
      return solar2
    } else {
      return solar1
    }
  }

  const style = {
    '--gauge-value': percent || 0,
  } as any
  
  return (
    <Style $right={isEng ? '7%' : '12%'}>
      <div className='column-1'>
        <div className='text-kw'>
          <Text $maxSize='0.6' $minSize='10'>
            Power [Kw]
          </Text>
        </div>
        <div className='graph'>
          <div className='text'>
            <Text $maxSize='1.6' $minSize='22'>
              {t('middle.solarPower')}
            </Text>
          </div>
          <div className='chart-container'>
            <div className='bar-chart-container'>
              <Chart chartConfig={chartConfig} />
            </div>
          </div>
          <img className='box' src={IMG['graph-box.svg']} alt={IMG['graph-box.svg']} />
        </div>
      </div>
      <div className='column-2'>
        <img className='solar' src={solar()} alt={solar()} />
        <div className='electricPole'>
          <Animation
            options={{
              animationData,
              loop: true,
              initialSegment: [10, 150],
            }}
          />
        </div>
        <img className='box' src={IMG['solar-box.svg']} alt={IMG['solar-box.svg']} />
        <div className='gauge-box'>
          <div
            className='gauge'
            style={style}
          >
            <div className='needle'>
              <img
                className='needle-head'
                src={IMG['solar-scale.svg']}
                alt={IMG['solar-scale.svg']}
              />
            </div>
          </div>
        </div>
        <div className='text'>
          <Text $maxSize='1.4' $minSize='20' top={isEng ? '10%' : '12%'}>
            {t('middle.currentSolar')}
          </Text>
          <Text $maxSize='2.8' $minSize='40'>
            {currentPower} kW
          </Text>
        </div>
      </div>
    </Style>
  )
}
